import DeviceUUID from "device-uuid";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const sendToOpenAI = async (
  userText: string,
  onChunk?: (chunk: string) => void,
  threadId?: string
): Promise<{ response: string; threadId?: string }> => {
  try {
    const deviceId = new DeviceUUID.DeviceUUID().get();
    const tokenId = deviceId + "-" + Date.now();
    const body = {
      deviceId,
      tokenId,
      query: userText,
      threadId, // Include threadId if provided
    };

    const response = await fetch(`${BASE_URL}/pitchStream`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      console.error(
        "API error: response not ok",
        response.status,
        response.statusText
      );
      throw new Error("API error");
    }

    const reader = response.body?.getReader();
    if (!reader) {
      throw new Error("Response body is not readable");
    }

    const decoder = new TextDecoder("utf-8");
    let fullResponse = "";
    let receivedThreadId: string | undefined = undefined;
    const jsonRegex = /{[^}]+}/g;

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const chunk = decoder.decode(value, { stream: true });
      console.log("[OpenAI API chunk]", chunk); // Log raw chunk
      fullResponse += chunk;

      const matches = chunk.match(jsonRegex) || [];
      matches.forEach((jsonStr) => {
        try {
          const obj = JSON.parse(jsonStr);
          if (obj.threadId && !receivedThreadId) {
            receivedThreadId = obj.threadId;
          }
          if (typeof obj.response === "string" && onChunk) {
            console.log("[API chunk received]", obj.response); // Log each chunk
            onChunk(obj.response);
          }
        } catch (jsonErr) {
          console.error("JSON parse error in chunk:", jsonStr, jsonErr);
        }
      });
    }

    const finalResponse = fullResponse
      .match(jsonRegex)
      ?.map((jsonStr) => {
        try {
          return JSON.parse(jsonStr).response || "";
        } catch {
          return "";
        }
      })
      .join("")
      .trim();

    return {
      response: finalResponse || "Sorry, I couldn't generate a response.",
      threadId: receivedThreadId,
    };
  } catch (err) {
    console.error("Caught error in sendToOpenAI:", err);
    if (onChunk) {
      onChunk("Sorry, there was an error contacting OpenAI.");
    }
    return {
      response: "Sorry, there was an error contacting OpenAI.",
      threadId: undefined,
    };
  }
};
